const duplex = require('duplexer')
const pump = require('pump')

const requestStream = require('airship/modules/request2/stream')

const addCSRF = require('airship/modules/request2/transforms/csrf')
const addKeymaster = require('airship/modules/request2/transforms/keymaster')
const json = require('airship/modules/request2/transforms/json')
const addUAAccept = require('airship/modules/request2/transforms/ua-accept')

module.exports = createUAStream

function createUAStream() {
  const uaAccept = addUAAccept()
  const jsonDecode = json.decode()
  const stream = duplex(uaAccept, jsonDecode)

  pump(
    uaAccept,
    addCSRF(),
    addKeymaster(),
    json.encode(),
    requestStream(),
    jsonDecode,
    function(err) {
      if (!err) return

      stream.emit('error', err)
    }
  )

  return stream
}
